module.exports = __webpack_public_path__ + "img/avatar.8b5e1ddc.svg";